import { CircularProgress } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext, useState } from "react";
import TextError from "../../../Components/HealthInsFormikComponent/TextError";

import Moment from "moment";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";
import StarAdhrPrfPos from "./StarAdhrPrfPos";
import { RefIdContext } from "../Context/RefIdContext";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

const StarCKYCForm = (props) => {
  const starReqCKYC = {
    documentId: 1,
    documentNumber: "PASS68463872972",
  };
  const {
    setCKYCVerified,
    setNext,
    setckycId,
    decryptedResponseId,
    decryptedAcuvisor_product_id,
    a_id
  } = props;
  const [submitForm, setSubmitForm] = useState(false);

  const initialValues = {
    docTypeSelect: "7",
    docNumber: "",

    gender: "",
    star_adhaar_dob: "",
    applicantName: "",
    adhaarNum: "",
  };

  const selectFieldOptions = [
    "Select Document Type then enter",
    "Enter PassPort Number",
    "Enter Voter Id Number",
    "Enter Driving Licence Number",
    "Proof of Possession of Aadhaar",
    "Enter NREGA Job Card Number",
    "Enter National Population Register Letter Number",
    "Enter PAN Number",
    "Enter Certificate of Incorporation /Formation Number",
    "Enter Registration Certificate Number",
    "Enter CKYC Identifier Number",
  ];

  const validationSchema = Yup.object().shape({
    docTypeSelect: Yup.string().required("Document type must be provided"),
    docNumber: Yup.mixed()
      // .when("docTypeSelect", {
      //   is: "4",
      //   then: Yup.mixed().notRequired(),
      // })
      .when("docTypeSelect", {
        is: "1",
        then: Yup.string()
          .required("Document type must be provided")
          .min(8, "Passport number must be at least 8 characters long")
          .max(20, "Passport number must not be more than 20 characters long"),
        // .matches(
        //   //  TODO: to find a valid indian passport regex
        //   // /^[A-Z]{2}\d{6}$/,
        //   /^[A-Za-z]{1}[0-9]{7}$/,
        //   "Passport number must be in the format A1234567"
        // ),
      })
      .when("docTypeSelect", {
        is: "7",
        then: Yup.string()
          .required("Document type must be provided")
          .matches(
            /([A-Z]){5}([0-9]){4}([A-Z]){1}$/,
            "Please Give valid Pan Number"
          )
          .min(10, "Pan Number must have 10 digits")
          .max(10, "Pan Number must not exceed 10 digits"),
      })
      .when("docTypeSelect", {
        is: "10",
        then: Yup.string()
          .required("Document type must be provided")
          .matches(/^[0-9]+$/, "Only numbers are allowed")
          .min(14, "CKYC Number must have 14 digits")
          .max(14, "CKYC Number must not exceed 14 digits"),
      })
      .when("docTypeSelect", {
        is: (value) =>
          value !== "1" && value !== "4" && value !== "7" && value !== "10",
        then: Yup.string()
          .required("Document type must be provided")
          .max(20, "Document Number must not exceed 20 digits"),
      }),
    gender: Yup.mixed().when("docTypeSelect", {
      is: "4",
      then: Yup.string().required("Must Choose Gender"),
    }),
    star_adhaar_dob: Yup.mixed().when("docTypeSelect", {
      is: "4",
      then: Yup.string().required("Date of Birth must be provided"),
    }),
    applicantName: Yup.mixed().when("docTypeSelect", {
      is: "4",
      then: Yup.string().required("Name as per Adhaar is required"),
    }),
    adhaarNum: Yup.mixed().when("docTypeSelect", {
      is: "4",
      then: Yup.string()
        .required("Adhaar Last 4 digit Number is required")
        .matches(/^[0-9]+$/, "Only numbers are allowed")
        .min(4, "Cannot be less than 4-digit")
        .max(4, "Cannot exceed more than 4-digit"),
    }),
  });

  const onSubmit = async (data) => {
    console.log("sub", data);
    setSubmitForm(true);
    let newDocNum = data.docNumber;
    if (data.docTypeSelect === "4") {
      let dob =
        data.star_adhaar_dob === ""
          ? ""
          : Moment(data.star_adhaar_dob).format("DD-MM-YYYY");
      console.log("newDate", dob);

      newDocNum =
        "" +
        data.adhaarNum +
        "|" +
        data.applicantName +
        "|" +
        dob +
        "|" +
        data.gender;
    }
    let req = {
      ...starReqCKYC,
      documentId: data.docTypeSelect,
      documentNumber: newDocNum,
    };

    console.log("req", req);

    let domain = "";

     

    // `${domain}/api/health-insurance/starhealth/search-ckyc/${decryptedAcuvisor_product_id}/${decryptedResponseId}/`,
    await axiosInstance
      .post(
        `api/health-insurance/starhealth/search-ckyc/${a_id}/${decryptedResponseId}/`,
        JSON.stringify(req)
      )
      .then((response) => {
        if (response.status === 200) {
          console.log("Success");
          Swal.fire({
            icon: "success",
            title: `Your KYC is Verified\n CKYC-ID: ${response.data.ckycId}`,
            text: "Click on Next button to proceed",
            position: "center",

            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              // setEKYC(true)
              // setCKYC(false)
              // then move to genref page !
              setNext(true);
              setCKYCVerified(true);
              setckycId(response.data.ckycId)
              setSubmitForm(false);
            }
          });
        }
        console.log("response", response);
        setNext(true);
        setCKYCVerified(true);
        setckycId(response.data.ckycId)
        setSubmitForm(false);
      })
      .catch((error, response) => {
        if (error.response.status !== 200) {
          let errMSG = "";
          if (Array.isArray(error.response.data.message)) {
            errMSG = error.response.data.message[0].errDescription;
          } else {
            errMSG = error.response.data.message;
          }
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${errMSG}`,
            position: "center",
            showConfirmButton: true,
            confirmButtonText: "Continue",
            showCancelButton: true,
            cancelButtonText: "Re-Enter Document Number",
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              // setCKYC(false);  // Setting false to move to ekyc page i.e; gen_ref_id_form for star
              // setEKYC(true)
              // Move to gen ref_id_form
              setNext(true);
              setSubmitForm(false);
            } else if (result.dismiss === "cancel") {
              setSubmitForm(false);
              // setCKYC(true)
              // setEKYC(false)
            }
            console.log(result, "ff");
          });
          // alert()
          // setCKYC(false);  // Setting false to move to ekyc page i.e; gen_ref_id_form for star
          // setEKYC(true)
        }
        console.log("err", error.response);
        setSubmitForm(false);
      });
  };

  return (
    <div>
      {
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {(formik) => (
            <Form>
              {console.log("formik", formik)}
              <div className="form-container ">
                <div className="d-flex justify-content-center">
                  <h3>Individual Search CKYC</h3>
                </div>
                <div className="form-group mb-3 ">
                  <label htmlFor="docTypeSelect fw-bold">
                    Select Document Type
                  </label>
                  <Field
                    as="select"
                    name="docTypeSelect"
                    id="docTypeSelect"
                    className={
                      formik.touched.docType && formik.errors.docType
                        ? "errorStyle form-control bg-white"
                        : !formik.errors.docType && formik.touched.docType
                        ? "successField form-control bg-white"
                        : "form-control bg-white"
                    }
                  >
                    <option value="">Select Options</option>
                    <option value="1">PassPort</option>
                    <option value="2">Voter Id</option>
                    <option value="3">Driving Licence</option>
                    <option value="4">Proof of Possession of Aadhaar</option>
                    <option value="5">NREGA Job Card</option>
                    {/* <option value="6">
                      National Population Register Letter
                    </option> */}
                    <option value="7">PAN</option>
                    {/* <option value="8">
                      Certificate of Incorporation /Formation
                    </option> */}
                    <option value="9">Registration Certificate</option>
                    <option value="10">CKYC Identifier</option>
                  </Field>
                  <ErrorMessage name="docTypeSelect" component={TextError} />
                </div>

                {formik.values["docTypeSelect"] != 4 ? (
                  <div className="form-group  " style={{ paddingTop: "20px" }}>
                    <label
                      htmlFor="docNumber"
                      className="fw-light"
                      style={{ paddingBottom: "8px" }}
                    >
                      {
                        selectFieldOptions[
                          formik.values["docTypeSelect"]
                            ? formik.values["docTypeSelect"]
                            : 0
                        ]
                      }
                    </label>
                    <div className="input-icons">
                      <Field
                        type="text"
                        name="docNumber"
                        id="docNumber"
                        className={
                          formik.touched.docNumber && formik.errors.docNumber
                            ? " errorStyle form-control bg-white"
                            : !formik.errors.docNumber &&
                              formik.touched.docNumber
                            ? " successField form-control bg-white"
                            : " form-control bg-white"
                        }
                      />
                    </div>
                    <ErrorMessage name="docNumber" component={TextError} />
                  </div>
                ) : (
                  <StarAdhrPrfPos formik={formik} />
                )}

                <div className="mt-3">
                  {!submitForm ? (
                    <button
                      className="submitBtn text-capitalize "
                      type="submit"
                      //disabled={formik.isSubmitting}
                    >
                      Submit
                    </button>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <CircularProgress
                        size={48}
                        sx={{
                          color: "red",
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/*  <div className=" btn-sec  position-fixed bottom-0 ">
                            {
                                formik.isSubmitting ?
                                    <div className='mx-auto'>
                                        <CircularProgress
                                            size={48}
                                            sx={{
                                                color: 'red',

                                            }} />
                                    </div>

                                    :
                                    <>
                                        <button className="reset-btn text-capitalize"
                                            type="reset"
                                        //onClick={()=>resetForm()}
                                        >
                                            Reset
                                        </button>
                                        <button className="submitBtn text-capitalize " type="submit" disabled={formik.isSubmitting}>
                                            Submit
                                        </button>
                                    </>

                            }
                        </div> */}
            </Form>
          )}
        </Formik>
      }
    </div>
  );
};

export default StarCKYCForm;
